if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();

      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.dispatchMessage = this.querySelector('.js-inventory-urgency');
      this.variantInventory = this.getVariantInventory();

      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];

        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false, '');
      }
    }

    isBeforeDispatchCutoff() {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }).formatToParts(new Date()).map((p) => [p.type, p.value])
      );

      const isWeekday = !['Sat', 'Sun'].includes(parts.weekday);
      const isBefore3pm =
        Number(parts.hour) < 15 ||
        (Number(parts.hour) === 15 && Number(parts.minute) === 0);

      return isWeekday && isBefore3pm;
    }

    clearInventory() {
      this.hidden = true;
      this.removeAttribute('data-inventory-level');

      if (this.inventoryNotice) {
        this.inventoryNotice.innerText = '';
      }

      if (this.dispatchMessage) {
        this.dispatchMessage.innerHTML = '';
      }
    }

    updateInventory(count, available, inventoryPolicy) {
      if (!inventoryPolicy && !available && count <= 0) {
        this.clearInventory();
        return;
      }

      const isInStock = available && count > 0;
      const inventoryLevel = isInStock ? 'in_stock' : 'none';

      this.hidden = false;
      this.setAttribute('data-inventory-level', inventoryLevel);

      if (isInStock) {
        this.inventoryNotice.innerText = theme.strings.inStock;
        this.dispatchMessage.innerHTML = this.isBeforeDispatchCutoff()
          ? this.dataset.textNormal
          : '';
      } else {
        this.inventoryNotice.innerText = theme.strings.noStock;
        this.dispatchMessage.innerHTML = '';
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
